import { shallow } from "zustand/shallow";
import useUserStore from "../../../store/userStore";
import { useEffect } from "react";
import useReactiveQuery from "../../../hooks/data/useReactiveQuery";
import { NavButton } from "../../../ui_components/menubar";
import { FaHeadphonesSimple } from "react-icons/fa6";
import usePlaylist from "../../../hooks/data/usePlaylist";
import { RiPlayListLine } from "react-icons/ri";

const PlaylistList = () => {
  const { listPlaylistsByUser } = usePlaylist();
  const { id: stateUserId, username } = useUserStore(
    (state) => state.user,
    shallow
  );
  const { getAll } = useReactiveQuery();

  const allPlaylists = getAll(["playlists", username], {
    transform: (playlists) =>
      playlists.filter(
        (playlist) =>
          !(
            typeof playlist.get === "function" &&
            typeof playlist.data === "function"
          )
      ),
  });

  useEffect(() => {
    username && listPlaylistsByUser({ username });
  }, [username]);

  return (
    <>
      {allPlaylists?.map((playlist) => (
        <NavButton
          key={`room_${playlist.id}_navitem`}
          title={playlist.name}
          icon={<RiPlayListLine size={12} />}
          path={`/user/${username}/playlist/${playlist.id}`}
        />
      ))}
    </>
  );
};

export default PlaylistList;
